import { UAParser } from 'ua-parser-js';

const DeviceTypes = {
    Mobile: 'mobile',
    Tablet: 'tablet',
    SmartTv: 'smarttv',
    Console: 'console',
    Wearable: 'wearable',
    Browser: undefined,
};
const UA = new UAParser();
const device = UA.getDevice();
const isMobileType = () => device.type === DeviceTypes.Mobile;
const isMobileAndTabletType = () => {
    switch (device.type) {
        case DeviceTypes.Mobile:
        case DeviceTypes.Tablet:
            return true;
        default:
            return false;
    }
};
const isMobileOnly = isMobileType();
const isMobile = isMobileAndTabletType();

export { DeviceTypes, isMobile, isMobileOnly };
